// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// imports
import { FormLayout } from './form-layout.component';

@NgModule({
  declarations: [
    FormLayout,
  ],
  exports: [
    FormLayout,
  ],
  imports: [
    CommonModule,
  ]
})
class FormLayoutModule { }

export { FormLayout, FormLayoutModule };
